import LeadMagnetPage from "@/components/LeadMagnetPage";
import docShot from "@/assets/lm/appointment-setting-doc-cover-v2.png.asset.json";
import callTimes from "@/assets/lm/appointment-setting-call-times.png.asset.json";
import checklist from "@/assets/lm/appointment-setting-checklist.png.asset.json";

const LmAppointmentSetting = () => (
  <LeadMagnetPage c={{
    path: "/lm/appointment-setting", tag: "lm-appointment-setting", leadMagnet: "appointment-setting", eyebrow: "THE PLAYBOOK",
    headline: "Fill out the form and get access to the playbook now",
    subtitle: "The exact system behind 4,500+ booked homeowner appointments: what to do before, during and after the call.",
    cover: docShot.url,
    coverAlt: "Google Doc: LM: Appointment setting homeowners",
    coverWidth: 1274, coverHeight: 823,
    coverClassName: "mx-auto block w-full max-w-[200px] rounded-xl border border-white/10 shadow-[0_30px_70px_-20px_rgba(0,0,0,0.8)] md:max-w-none",
    footerLink: { href: "/lm/script-builder", label: "Prefer a script built for your business? Build it with AI →" },
    ctaLabel: "Text me the link now",
    seoTitle: "Free Homeowner Appointment-Setting Playbook",
    seoDescription: "Free playbook for remodelers and home-service businesses: the exact system behind 4,500+ booked homeowner appointments, before, during and after the call.",
    extraImages: [
      {
        src: callTimes.url,
        alt: "Inside the playbook: the best time to call homeowners, by day and hour",
        width: 669, height: 539,
      },
      {
        src: checklist.url,
        alt: "Inside the playbook: the appointment-setting checklist",
        width: 811, height: 394,
      },
    ],
  }} />
);

export default LmAppointmentSetting;
